import {PubSub} from "../utility/PubSub";
import ReactGA4 from "react-ga4";
import ReactGA from 'react-ga';

export type AnalyticsData = {
   [key: string]: string | undefined
}

export enum AnalyticsEvent {
   trackAppStart = "trackAppStart",
   trackStepChange = "trackStepChange",
   trackCompletion = "trackCompletion",
   trackViewHistory = "trackViewHistory",
   trackTermsRead = "trackTermsRead",
   trackItemCategory = "trackItemCategory",
   trackServiceDenied = "trackServiceDenied",
   trackItemAdd = "trackItemAdd",
   trackItemImage = "trackItemImage",
   trackItemDialog = "trackItemDialog",
   trackError = "trackError"
}

interface AnalyticsEventDataType {
   [id: string]: {
      category: string
   }
}

export const AnalyticsEventData: AnalyticsEventDataType = {
   [AnalyticsEvent.trackAppStart]: {
      category: 'Initialization'
   },
   [AnalyticsEvent.trackStepChange]: {
      category: 'Navigation'
   },
   [AnalyticsEvent.trackCompletion]: {
      category: 'TradeIn'
   },
   [AnalyticsEvent.trackViewHistory]: {
      category: 'History'
   },
   [AnalyticsEvent.trackTermsRead]: {
      category: 'TradeIn'
   },
   [AnalyticsEvent.trackItemCategory]: {
      category: 'TradeIn'
   },
   [AnalyticsEvent.trackServiceDenied]: {
      category: 'Initialization'
   },
   [AnalyticsEvent.trackItemAdd]: {
      category: 'TradeIn'
   },
   [AnalyticsEvent.trackItemImage]: {
      category: 'TradeIn'
   },
   [AnalyticsEvent.trackItemDialog]: {
      category: 'TradeIn'
   }
}

export type AnalyticsPayload = {
   event: AnalyticsEvent
   data: AnalyticsData
}

const event = (event: AnalyticsEvent, data?: AnalyticsData) => {
   PubSub.emit('analytics', {
      event: event,
      data: data || {}
   } as AnalyticsPayload)
}

const initialize = (ua?: string | null, ga4?: string | null) => {
   if (ua) {
      ReactGA.initialize(ua)
   }
   if (ga4) {
      ReactGA4.initialize(ga4)
   }
}

export const Analytics = {
   event,
   initialize
}